module.exports = __webpack_public_path__ + "static/media/addmemebererror.4efbb33d.svg";